import React, { useEffect, useState, useRef } from 'react';
import './filterForm.css';
import ColumnFilterDropdown from '../ColumnFilterDropdown/ColumnFilterDropdown';

const FilterForm = ({
  field,
  translated_field,
  applyFilters,
  fieldName,
  fieldType,
  data_type,
  searchParams,
  sort,
  handleSortChange,
  closeForm,
}) => {
  const [filterValue, setFilterValue] = useState('');
  const [minValue, setMinValue] = useState('');
  const [maxValue, setMaxValue] = useState('');
  const formRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        closeForm();
      }
    };

    const handleKeyDown = event => {
      if (event.key === 'Enter') {
        closeForm();
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeForm]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (fieldName === 'chartering_datetime' && searchParams.get('shipment_stage') === 'EN COURS') {
      const today = new Date().toISOString().split('T')[0];
      setMinValue(today);
      setMaxValue(today);
    }
  }, [fieldName, searchParams]);

  const handleTextFilterChange = e => {
    const value = e.target.value;
    setFilterValue(value);
  };

  const handleMinChange = e => {
    const value = e.target.value;
    setMinValue(value);
  };

  const handleMaxChange = e => {
    const value = e.target.value;
    setMaxValue(value);
  };

  const handleKeyDown = e => {
    const value = e.target.value;
    if (e.key === 'Enter') {
      if (fieldType === 'boolean') {
        if (value.toLowerCase() === 'oui' || value.toLowerCase() === 'yes') {
          applyFilters([field, true]);
        } else if (value.toLowerCase() === 'non' || value.toLowerCase() === 'no') {
          applyFilters([field, false]);
        }
      } else {
        applyFilters([field, value]);
      }
      closeForm();
    }
  };

  const handleApplyNumbers = e => {
    let newFilters = [];
    if (minValue) {
      newFilters.push([`${field}_gte`, minValue]);
    }
    if (maxValue) {
      newFilters.push([`${field}_lte`, maxValue]);
    }
    if (newFilters.length > 0) {
      applyFilters(...newFilters);
    }
    closeForm();
  };

  const get_filter_input = () => {
    if (fieldType === 'text' || fieldType === 'email' || fieldType === 'boolean') {
      return (
        <input
          ref={inputRef}
          type="text"
          value={filterValue}
          onChange={handleTextFilterChange}
          onKeyDown={handleKeyDown}
          placeholder={`Filtrer ${translated_field}`}
        />
      );
    } else if (
      fieldType === 'date' ||
      fieldType === 'number' ||
      fieldType === 'currency' ||
      fieldType === 'percentage'
    ) {
      return (
        <>
          <input
            ref={inputRef}
            type={fieldType}
            value={minValue}
            onChange={handleMinChange}
            placeholder={`Min ${translated_field}`}
          />
          <p> à </p>
          <input
            type={fieldType}
            value={maxValue}
            onChange={handleMaxChange}
            placeholder={`Max ${translated_field}`}
          />
          <button type="button" onClick={handleApplyNumbers}>
            Ok
          </button>
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <div ref={formRef} className="filter-form">
      {get_filter_input()}
      <div className="sort-buttons-container">
        <div
          className="sort-button"
          onClick={() => {
            handleSortChange(fieldName, 'desc');
            closeForm();
          }}
        >
          Du plus grand au plus petit
        </div>
        <div
          className="sort-button"
          onClick={() => {
            handleSortChange(fieldName, 'asc');
            closeForm();
          }}
        >
          Du plus petit au plus grand
        </div>
      </div>
      <div className="column-filter-dropdown-wrapper">
        <ColumnFilterDropdown
          data_type={data_type}
          columnName={fieldName}
          columnType={fieldType}
          searchParams={searchParams}
          sort={sort}
          applyFilters={applyFilters}
          multiSelectable={false}
          closeForm={closeForm}
        />
      </div>
    </div>
  );
};

export default FilterForm;
